import IotWebSocketClient from './iotWebSocketClient';

export default class IotDeviceWebSocketClient extends IotWebSocketClient {
    constructor(assetId, createNew = false, options) {
        super(assetId, createNew, options, 'IotDeviceWebSocketClient');
    }
}
